import * as tslib_1 from "tslib";
import { resetFocus } from 'owa-mail-focus-manager';
import { getCustomIcon } from 'owa-mail-folder-forest-actions';
import { createNewFolder } from 'owa-mail-folder-store/lib/actions/newFolder';
import { listViewStore } from 'owa-mail-list-store';
import { getMoveToMenuProps, } from 'owa-mail-moveto-control';
import * as lazyTriageActions from 'owa-mail-triage-action';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import isItemPartCommandBarOperation from 'owa-mail-list-store/lib/selectors/isItemPartCommandBarOperation';
import { lazyShowSweepDialog } from 'owa-mail-sweep-view';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { MOVETO_WIDTH } from '../utils/constants';
import { isFeatureEnabled } from 'owa-feature-flags';
var styles = require('./MailMoveToMenuStyles.scss');
/**
 * Gets focused and other menu items
 */
function getFocusedOtherMenuItems(tableView, className, onAfterMenuClicked, actionSource, shouldShowBehaviorMap) {
    var items = [];
    // Add move to Focused/Other
    if (shouldShowBehaviorMap[17 /* MoveToFocusedInbox */]()) {
        items.push(React.createElement("div", { key: 'moveTo' + strings.moveToFocusedInboxText, className: className, "data-is-focusable": true, onClick: function () {
                lazyTriageActions.lazyMoveMailListRowsToFocusedOrOther.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, actionSource);
                onAfterMenuClicked();
            } },
            React.createElement("span", { className: styles.moveToFocusedOtherMenuItems }, strings.moveToFocusedInboxText)));
    }
    else if (shouldShowBehaviorMap[18 /* MoveToOtherInbox */]()) {
        items.push(React.createElement("div", { key: 'moveTo' + strings.moveToOtherInboxText, className: className, "aria-label": strings.moveToOtherInboxText, role: 'menuitem', "data-is-focusable": true, onClick: function () {
                lazyTriageActions.lazyMoveMailListRowsToFocusedOrOther.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, actionSource);
                onAfterMenuClicked();
            } },
            React.createElement("span", { className: styles.moveToFocusedOtherMenuItems }, strings.moveToOtherInboxText)));
    }
    // Add always move to focused other
    if (shouldShowBehaviorMap[0 /* AlwaysMoveToFocusedInbox */]()) {
        items.push(React.createElement("div", { key: 'moveTo' + strings.alwaysMoveToFocusedInboxText, className: className, "data-is-focusable": true, onClick: function () {
                lazyTriageActions.lazyAlwaysMoveRowToFocusedOrOther.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, actionSource);
                onAfterMenuClicked();
            } },
            React.createElement("span", { className: styles.moveToFocusedOtherMenuItems }, strings.alwaysMoveToFocusedInboxText)));
    }
    else if (shouldShowBehaviorMap[1 /* AlwaysMoveToOtherInbox */]()) {
        items.push(React.createElement("div", { key: 'moveTo' + strings.alwaysMoveToOtherInboxText, className: className, "aria-label": strings.alwaysMoveToOtherInboxText, role: 'menuitem', "data-is-focusable": true, onClick: function () {
                lazyTriageActions.lazyAlwaysMoveRowToFocusedOrOther.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, actionSource);
                onAfterMenuClicked();
            } },
            React.createElement("span", { className: styles.moveToFocusedOtherMenuItems }, strings.alwaysMoveToOtherInboxText)));
    }
    return items;
}
/**
 * Gets custom menu items for the move to context menu.
 * Custom items will be added to the end of the menu.
 * @param tableView tableView where the move is being performed
 * @param shouldShowBehaviorMap the behavior map used to determine which items to show
 */
function getSweepMenuItem(tableView, shouldShowBehaviorMap) {
    return shouldShowBehaviorMap[34 /* Sweep */]() &&
        isMailFeatureEnabled('tri-moveToSweepOption')
        ? [
            {
                title: 'sweep',
                displayText: strings.moveToFolderMoveAllFrom,
                onClick: function () {
                    lazyShowSweepDialog.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView);
                },
            },
        ]
        : null;
}
/**
 * Moves given rows to a specified folder
 * @param tableView tableView where the move is being performed
 * @param destinationFolderId - the destination folder
 * @param rowKeysToMove the list of rowKeys which will be moved
 */
function moveRows(tableViewId, rowKeysToMove, destinationFolderId, actionSource) {
    lazyTriageActions.lazyMoveMailListRows.importAndExecute(tslib_1.__spread(rowKeysToMove), destinationFolderId, tableViewId, actionSource);
}
/**
 * Gets the moveto folder menu items for command bar
 * @param tableView the tableView
 * @param actionSource the actionSource
 * @param shouldShowBehaviorMap the behavior map to determine the triage action behavior in a current context
 * @return returns the contextual menu items
 */
export function getMoveToPropertiesForCommandBar(tableView, actionSource, shouldShowBehaviorMap) {
    return getMoveToMenuProperties(tableView, true /* shouldShowSearchBox */, function () { return resetFocus(); }, // always reset focus to dismiss the menu from commanding bar
    actionSource, 'CommandBar', shouldShowBehaviorMap);
}
/**
 * Gets the moveto folder menu items for context menu
 * @param tableViewId the tableView id
 * @param dismissMenu the callback to be called to dismiss of menu
 * @param actionSource the actionSource
 * @param shouldShowBehaviorMap the behavior map to determine the triage action behavior in a current context
 * @param rowKeysToMove the list of rowKeys which will be moved
 * @return returns the contextual menu items
 */
export function getMoveToPropertiesForContextMenu(tableViewId, dismissMenu, actionSource, shouldShowBehaviorMap, rowKeysToMove, shouldShowSearchBox) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    return getMoveToMenuProperties(tableView, shouldShowSearchBox /* shouldShowSearchBox */, dismissMenu, // Callback to dismiss the right click context menu
    actionSource, 'ContextLV', shouldShowBehaviorMap, 11 /* rightTopEdge */, rowKeysToMove);
}
/**
 * Gets the move to folder menu items
 * @param tableView the tableView
 * @param shouldShowSearchBox flag indicating whether to show search box or not
 * @param dismissMenu callback to be called to dismiss the move to menu context menu
 * @param actionSource the actionSource
 * @param moveToActionSource the move to menu action source
 * @param shouldShowBehaviorMap the behavior map to determine the triage action behavior in a current context
 * @param directionalHint determines which direction the callout appears, defaults to bottomLeftEdge
 * @param rowKeysToMove the list of rowKeys which will be moved
 * @return returns the contextual menu items
 */
function getMoveToMenuProperties(tableView, shouldShowSearchBox, dismissMenu, actionSource, moveToActionSource, shouldShowBehaviorMap, directionalHint, rowKeysToMove) {
    var supportedMoveToMailboxContexts = ['primary', 'archive'];
    if (isFeatureEnabled('tri-sharedFolders')) {
        supportedMoveToMailboxContexts.push('sharedFolder');
    }
    var moveToMenuProps = getMoveToMenuProps({
        supportedMoveToMailboxContexts: supportedMoveToMailboxContexts,
        shouldShowSearchBox: shouldShowSearchBox,
        actionSource: moveToActionSource,
        createNewFolder: createNewFolder,
        dismissMenu: dismissMenu,
        onFolderClick: function (folderId) {
            if (moveToActionSource == 'CommandBar' && isItemPartCommandBarOperation(tableView.id)) {
                lazyTriageActions.lazyMoveItemsBasedOnNodeIds
                    .import()
                    .then(function (moveItemsBasedOnNodeIds) {
                    moveItemsBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, folderId, tableView.id, 'CommandBar');
                });
            }
            else {
                // Check if rowKeys are explicitly passed (ex: in the case of moveTo quick action). In this case,
                // the move operation will be performed on the passed 'rowKeysToMove'.
                rowKeysToMove
                    ? moveRows(tableView.id, rowKeysToMove, folderId, actionSource)
                    : moveRows(tableView.id, tslib_1.__spread(tableView.selectedRowKeys.keys()), folderId, actionSource);
            }
        },
        getFocusedOtherMenuItems: function (className, onAfterMenuClicked) {
            return getFocusedOtherMenuItems(tableView, className, onAfterMenuClicked, actionSource, shouldShowBehaviorMap);
        },
        getCustomIcon: getCustomIcon,
        directionalHint: directionalHint,
        customMenuItemsToAppend: getSweepMenuItem(tableView, shouldShowBehaviorMap),
        width: MOVETO_WIDTH,
    });
    return moveToMenuProps;
}
//# sourceMappingURL=getMoveToMenuProperties.js.map